import { render } from "./KreyativCta.vue?vue&type=template&id=ca6c943a&scoped=true"
const script = {}

import "./KreyativCta.vue?vue&type=style&index=0&id=ca6c943a&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.2.13_webpack@5.88.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca6c943a"]])

export default __exports__